/* ---------------------------------------------------------------
   Lin & Lore - kortingsregel in de winkelwagenlade

   HET PROBLEEM
   snippets/cart-drawer.liquid rendert cart.cart_level_discount_applications
   nergens. Bij drie artikelen zag de klant dus 374,85 doorgestreept naar
   94,40, zonder ergens te lezen waardoor. Precies de bevestiging die de
   staffel moet geven ontbrak op het moment dat hij het meeste waard is.

   WAAROM IN EEN EIGEN BESTAND
   assets/cart-drawer.js is 19 kB van het thema zelf en werkt de footer bij
   via losse data-attributen, niet door opnieuw te renderen. Een regel in
   Liquid zou na een hoeveelheidswissel blijven staan op de oude waarde.
   Dit bestand raakt geen enkel themabestand aan: het tekent de regel zelf
   en hertekent hem zodra het subtotaal verandert.

   WAT HET TOONT
   De echte titel van de korting uit Shopify, dus 'Extra 20% korting' of
   'Extra 30% korting', met het werkelijk toegekende bedrag. Nooit een zelf
   berekend percentage: de staffel kan wijzigen zonder dat dit bestand
   meeverandert.
   --------------------------------------------------------------- */

(function () {
  'use strict';

  function geld(centen) {
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(centen / 100);
    } catch (e) {
      return '€ ' + (centen / 100).toFixed(2).replace('.', ',');
    }
  }

  function stijl() {
    if (document.getElementById('ll-cart-korting-stijl')) return;
    var s = document.createElement('style');
    s.id = 'll-cart-korting-stijl';
    s.textContent =
      '.ll-cart-korting{display:flex;align-items:baseline;justify-content:space-between;gap:12px;margin-bottom:6px}' +
      '.ll-cart-korting__label{font-size:14px;line-height:1.4;color:var(--ll-muted,#6B655F)}' +
      '.ll-cart-korting__bedrag{font-size:14px;line-height:1.4;font-weight:600;white-space:nowrap;color:var(--ll-accent,#00875A)}';
    document.head.appendChild(s);
  }

  function teken(cart) {
    var vak = document.querySelector('.cart-drawer__summary');
    if (!vak) return;

    var oud = vak.querySelectorAll('[data-ll-korting]');
    for (var i = 0; i < oud.length; i++) oud[i].parentNode.removeChild(oud[i]);

    var kortingen = (cart && cart.cart_level_discount_applications) || [];
    if (!kortingen.length) return;

    stijl();
    var eerste = vak.firstElementChild;

    for (var j = 0; j < kortingen.length; j++) {
      var k = kortingen[j];
      if (!k.total_allocated_amount) continue;

      var rij = document.createElement('div');
      rij.className = 'cart-drawer__summary-row ll-cart-korting';
      rij.setAttribute('data-ll-korting', '');

      var naam = document.createElement('span');
      naam.className = 'll-cart-korting__label';
      naam.textContent = k.title || 'Korting';

      var bedrag = document.createElement('span');
      bedrag.className = 'll-cart-korting__bedrag';
      bedrag.textContent = '−' + geld(k.total_allocated_amount);

      rij.appendChild(naam);
      rij.appendChild(bedrag);
      vak.insertBefore(rij, eerste);
    }
  }

  var bezig = false;
  var wacht = null;

  function ververs() {
    if (bezig) return;
    bezig = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(teken)
      .catch(function () {})
      .then(function () { bezig = false; });
  }

  function straks() {
    clearTimeout(wacht);
    wacht = setTimeout(ververs, 120);
  }

  function start() {
    ververs();

    // Het thema werkt het subtotaal bij zonder de lade opnieuw te renderen.
    // Verandert dat bedrag, dan is de winkelwagen gewijzigd en hertekenen we.
    var totaal = document.querySelector('[data-cart-drawer-subtotal]');
    if (totaal) {
      new MutationObserver(straks).observe(totaal, { childList: true, characterData: true, subtree: true });
    }

    // en zodra de lade opengaat, voor het geval er buiten de lade om is gewijzigd
    var lade = document.querySelector('[data-cart-drawer]');
    if (lade) {
      new MutationObserver(function () {
        if (lade.getAttribute('aria-hidden') === 'false') straks();
      }).observe(lade, { attributes: true, attributeFilter: ['aria-hidden', 'class'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();